var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"playerAvatarContainer",class:{ horizontal: _vm.horizontal }},[(_vm.$store.state.avatars.length)?_c('div',{staticClass:"playerAvatar",style:({
    width: `${_vm.scale * 20}px`,
    height: `${_vm.scale * 20}px`,
    backgroundColor: `#${_vm.player.color}`,
  })},[_c('img',{attrs:{"src":_vm.$store.state.avatars[_vm.player.avatar].image.sizes.thumbnail.url}})]):_vm._e(),(_vm.showUsername)?_c('div',{staticClass:"username"},[_vm._v(_vm._s(_vm.player.username))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }